import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import {
  checkIsNoResultToolOutput,
  type NoResultToolOutput,
} from "@repo/app-types/agents/noResultToolOutput";
import type {
  GetSampleSectionApplicabilityToolInput,
  GetSampleSectionApplicabilityToolOutput,
} from "@repo/app-types/entities/configurationAgent";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const GetSampleSectionApplicabilityTool: ToolComponent<
  GetSampleSectionApplicabilityToolInput,
  | GetSampleSectionApplicabilityToolOutput
  | MastraErrorToolOutput
  | NoResultToolOutput
> = (props) => {
  if (props.status.type === "running") {
    return (
      <ChatToolBase status={props.status}>
        Getting sample section applicability
      </ChatToolBase>
    );
  }

  // An expected condition (section not found, no samples in the window, ...) —
  // surface the feedback as a completed, not failed, tool call.
  if (checkIsNoResultToolOutput(props.output)) {
    return (
      <ChatToolBase status={props.status}>{props.output.message}</ChatToolBase>
    );
  }

  if (checkIsMastraErrorToolOutput(props.output)) {
    return (
      <ChatToolBase status={props.status}>
        An error occurred while getting sample section applicability
      </ChatToolBase>
    );
  }

  if (props.status.type === "complete" && props.output) {
    if (typeof props.output.sample_size !== "number") {
      return (
        <ChatToolBase status={props.status}>
          No sample interactions available for this section
        </ChatToolBase>
      );
    }
    return (
      <ChatToolBase status={props.status}>
        Analyzed section applicability on{" "}
        {props.output.sample_size.toLocaleString()} interactions
      </ChatToolBase>
    );
  }

  return (
    <ChatToolBase status={props.status}>
      Getting sample section applicability...
    </ChatToolBase>
  );
};
